import { ClientGroup, ClientGroupMemberAccessTypes, Relationship } from '../interfaces';

const filterHouseholdsWithAccess = (households: ClientGroup[], userId?: string) => (
  households.filter((household: ClientGroup) => household.relationships.some((rel: Relationship) => rel.user.id === userId && rel.accessType !== ClientGroupMemberAccessTypes.NoAccess))
);

export default filterHouseholdsWithAccess;
